import { FC } from 'react'
import orderBy from 'lodash/orderBy'
import map from 'lodash/map'
import ModuleWrapper2020 from 'components/features/pfm/ModuleWrapper2020/ModuleWrapper2020'
import { useStoreDispatch, useStoreSelector } from 'helpers/reactReduxHelpers'
import styles from 'components/features/coaching/advisorPage/AllSessions/AllSessions.styl'
import { AdvisorHeaderWith } from 'components/features/coaching/advisor/AdvisorHeaderWith/AdvisorHeaderWith'
import moment from 'moment'
import cn from 'classnames'
import Button from 'components/features/pfm/Button/Button'
import { meetingsSelector } from 'components/features/coaching/advisorMeeting/selectors/advisorsSelector'
import { modifyFloatingPaneActionCreator } from 'actions/floatingPanesActions'
import { topicsMap } from 'components/features/coaching/advisorMeeting/fixtures/requestQuestions'
import { isMobileSelector } from 'selectors/viewportSelectors'
import { MEETING_STATUS_MAP } from 'components/features/coaching/advisorMeeting/types/constants'

type AllSessionsProps = {}
export const AllSessions: FC<AllSessionsProps> = () => {

  const dispatch = useStoreDispatch()

  const meetings = useStoreSelector(meetingsSelector)
  const isMobile = useStoreSelector(isMobileSelector)

  if (!meetings || meetings.allKeys.length <= 0) {
    return null
  }

  const headerRow = !isMobile && (
    <li className={ cn(styles.meetingRow, styles.headerRow) } data-qa-marker='table-header'>
      <div data-qa-type='day'>Day</div>
      <div data-qa-type='time'>Time</div>
      <div data-qa-type='coach'>Coach</div>
      <div data-qa-type='topics'>Topics</div>
      <div data-qa-type='status'>Status</div>
      <div />
    </li>
  )

  const sortedMeetings = orderBy(meetings.byKey, 'timeslot', ['desc'])

  const meetingRows = map(sortedMeetings, (meeting, index) => {
    if (!meeting || !meeting.topics) {
      return null
    }

    const topicsChild = meeting.topics.answer.map((topicSlug) => topicsMap[topicSlug]).join(', ')

    const dayChild = <span data-qa-type='day'>{moment(meeting.timeslot).format('MMM Do')}</span>
    const timeChild = <span data-qa-type='time'>{moment(meeting.timeslot).format('h:mm A')}</span>

    const statusChild = (
      <div className={ cn(styles.status, styles[meeting.status]) } data-qa-type='session-status'>
        { MEETING_STATUS_MAP[meeting.status] }
      </div>
    )

    const mobileDateRow = (
      <li
        key={ meeting.uid }
        className={ styles.mobileRow }
        data-qa-marker='session-row'
        data-qa-type={ index }
        onClick={ () => {
          dispatch(modifyFloatingPaneActionCreator('advisor', { mode: 'meeting', uid: meeting.uid }))
        } }
      >
        <div className={ styles.mobileRowTop } data-qa-marker='header'>
          <div>
            <span data-qa-type='date'>{ moment(meeting.timeslot).format('MMMM Do') }</span>
            <span className={ styles.thin }> at </span>
            { timeChild }
          </div>
          { statusChild }
        </div>
        <div className={ styles.mobileRowBottom } data-qa-marker='content'>
          <AdvisorHeaderWith uid={ meeting.advisorUid } smallAvatar qaMarker='advisor-info' />
          <Button style='textOnly' size='tiny' qaMarker='details-button'>DETAILS</Button>
        </div>
      </li>
    )

    return isMobile ? mobileDateRow : (
      <li
        key={ meeting.uid }
        className={ styles.meetingRow }
        data-qa-marker='session-row'
        data-qa-type={ index }
        onClick={ () => {
          dispatch(modifyFloatingPaneActionCreator('advisor', { mode: 'meeting', uid: meeting.uid }))
        } }
      >
        { dayChild }
        { timeChild }
        <AdvisorHeaderWith uid={ meeting.advisorUid } smallAvatar qaMarker='advisor-info' />
        <div data-qa-type='topics'>{ topicsChild }</div>
        <div>{ statusChild }</div>
        <Button style='textOnly' size='tiny' qaMarker='details-button'>DETAILS</Button>
      </li>
    )
  })

  return (
    <ModuleWrapper2020
      title='All Sessions'
      card={ false }
      isFlexLayout
      qaMarker='all-sessions-table'
    >
      <ul className={ styles.allSessions }>
        { headerRow }
        { meetingRows }
      </ul>
    </ModuleWrapper2020>
  )
}
